import { create } from 'zustand';

const usePopupStore = create((set) => ({
    isAlertPopup: false,
    alertData: {
        type: '',
        text: '',
        closeButton: '확인',
        confirmButton: '',
        url: '',
        visibleButton: false
    },
    showAlert: (data) => set((state) => ({
        isAlertPopup: true,
        alertData: { ...state.alertData, ...data }
    })),
    closeAlert: () => set({
        isAlertPopup: false,
        alertData: {
            type: '',
            text: '',
            closeButton: '확인',
            confirmButton: '',
            url: '',
            visibleButton: false
        }
    })
}));

export default usePopupStore;